import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../../../Globals';
import { HttpService } from '../../../services/http-service';
import { getSignupUserId, patchSignupProgress } from '../signup-user';

@Component({
  selector: 'app-payout-setup',
  templateUrl: './payout-setup.component.html',
  styleUrls: ['./payout-setup.component.scss']
})
export class PayoutSetupComponent implements OnInit {
  globals = Globals;
  isLoadingResults = false;
  connectStatus: any = null;

  constructor(
    private service: HttpService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const userId = getSignupUserId();
    if (!userId) {
      this.service.showError('Please complete registration first.', 'ERROR');
      this.router.navigate(['/registration/registration-details']);
      return;
    }

    this.route.queryParams.subscribe(params => {
      if (params.refresh === '1') {
        this.openStripeOnboarding();
        return;
      }
      this.loadConnectStatus();
    });
  }

  loadConnectStatus() {
    const userId = getSignupUserId();
    if (!userId) {
      return;
    }
    this.isLoadingResults = true;
    this.service.getRequest(this.globals.urls.signUp.noauth.connectStatus, {
      merchantId: userId,
      _id: userId
    }).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1 && res.data) {
          this.connectStatus = res.data;
          if (res.data.payoutReady) {
            this.markPayoutStepComplete();
          }
        }
      },
      () => {
        this.isLoadingResults = false;
      }
    );
  }

  markPayoutStepComplete() {
    try {
      localStorage.setItem('reg-payout-submitted', '1');
    } catch (e) {
      // ignore
    }
    patchSignupProgress({ signupStepCompleted: 2 });
  }

  openStripeOnboarding() {
    const userId = getSignupUserId();
    if (!userId) {
      return;
    }
    this.isLoadingResults = true;
    this.service.postRequest(this.globals.urls.signUp.noauth.connectOnboardingLink, {
      merchantId: userId,
      _id: userId
    }).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1 && res.data && res.data.url) {
          window.location.href = res.data.url;
        } else {
          this.service.showError(res.message || 'Could not start payout setup', 'ERROR');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(typeof err === 'string' ? err : ((err && err.message) || 'Payout setup failed'), 'ERROR');
      }
    );
  }

  continueToInsurance() {
    if (!this.canContinueToInsurance()) {
      this.service.showError('Please complete payout setup with Stripe first.', 'ERROR');
      return;
    }
    this.markPayoutStepComplete();
    this.router.navigate(['/registration/insurance-details']);
  }

  canContinueToInsurance(): boolean {
    if (!this.connectStatus) {
      return false;
    }
    if (this.connectStatus.payoutReady) {
      return true;
    }
    return !!(this.connectStatus.detailsSubmitted
      && this.connectStatus.connectStatus !== 'restricted');
  }

  statusMessage(): string {
    if (!this.connectStatus || !this.connectStatus.hasConnectedAccount) {
      return 'Set up payouts with Stripe so you can receive earnings from completed jobs.';
    }
    switch (this.connectStatus.connectStatus) {
      case 'active':
        return 'Your payout account is verified. You can continue to TCP & insurance.';
      case 'pending_verification':
        return 'Stripe is reviewing your information. You may continue, or wait until verification completes.';
      case 'action_required':
      case 'onboarding':
        return 'Stripe needs more information to enable payouts.';
      case 'restricted':
        return 'Your payout account needs attention. Please continue setup with Stripe.';
      default:
        return 'Complete secure payout setup with Stripe (bank and identity if required).';
    }
  }
}
